<template>
  <v-container fluid mb-12 mt-5 style="width: 90%">
    <v-row>
      <v-col sm="3" md="6" offset-lg="0" class="mb-1">
        <h1>Routes</h1>
        <v-spacer></v-spacer>
      </v-col>
      <v-spacer></v-spacer>
      <v-col sm="6" md="8" lg="5" class="flex-container">
        <v-spacer></v-spacer>
        <v-btn
          v-if="tableDisplay == `route_status`"
          color="primary"
          dark
          rounded
          small
          class="flex-c"
          @click="statusDialog = true"
        >
          Create Route Status
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          v-if="tableDisplay == `route_actions`"
          color="primary"
          dark
          rounded
          small
          class="flex-c"
          @click="actionDialog = true"
        >
          Create Action
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <hr />
    <div class="v-row">
      <v-col cols="6">
        <v-btn-toggle
          v-model="tableDisplay"
          tile
          color="deep-purple accent-3"
          group
          class="text-center"
          rounded
          mandatory
        >
          <v-btn v-if="showMainRoutes" value="routes"> Routes </v-btn>
          <v-btn v-if="loggedInPosition == 'Admin' || loggedInPosition == 'Regional Director' || loggedInPosition == 'Records Officer' || loggedInPosition == 'Office Head'" value="initiate_documents" class="pr-5"> For Route <Badge class="pr-2"/></v-btn>
          <v-btn v-if="loggedInPosition == 'Admin' || loggedInPosition == 'Regional Director' || loggedInPosition == 'Records Officer' || loggedInPosition == 'Regional Employee' || loggedInPosition == 'Office Head'" value="routes_assigned"> Assigned Routes </v-btn>
          <v-btn v-if="loggedInPosition == 'Admin' || loggedInPosition == 'Regional Director' || loggedInPosition == 'Records Officer'" value="route_status"> Route Status </v-btn>
          <v-btn v-if="loggedInPosition == 'Admin' || loggedInPosition == 'Regional Director' || loggedInPosition == 'Records Officer'" value="route_actions"> Actions </v-btn>
        </v-btn-toggle>
      </v-col>
    </div>
    <RoutesTable
      v-if="showMainRoutes"
      :search="search"
      :tableDisplay="tableDisplay"
      :isFetching="isFetchingRoute"
    />
    <RouteStatusTable @closeDialog="closeDialog" :statusDialog="statusDialog" :search="search" :tableDisplay="tableDisplay" 
      :isFetching="isFetchingRouteStatus"/>
    <RoutesAssignedTable :search="search" :tableDisplay="tableDisplay" 
      :isFetching="isFetchingAssignedRoute"/>
    <PendingDocuments :search="search" :tableDisplay="tableDisplay" 
      :isFetching="isFetchingPendingDocuments"/>
    <ActionTable @openDialog="openDialog" @closeDialog="closeDialog" :dialog="actionDialog" :search="search" :tableDisplay="tableDisplay" 
      :isFetching="isFetchingAction"/>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import DateRangePicker from "../../components/documents/DateFilter.vue";
import RoutesTable from '../../components/routes/RoutesTable';
import RouteStatusTable from '../../components/routes/RouteStatusTable';
import RoutesAssignedTable from '../../components/routes/RoutesAssignedTable';
import PendingDocuments from '../../components/routes/PendingDocuments';
import ActionTable from "../../components/actions/ActionsTable";
import Badge from '../../components/routes/Badge.vue'

export default {
  name: "Routes",
  components: {
    RoutesTable,
    RouteStatusTable,
    RoutesAssignedTable,
    PendingDocuments,
    // DateRangePicker,
    Badge,
    ActionTable,
  },
  data() {
    return {
      isFetchingRoute: false,
      isFetchingRouteStatus: false,
      isFetchingAssignedRoute: false,
      isFetchingPendingDocuments: false,
      isFetchingAction: false,
      singleSelect: false,
      search: "",
      tableDisplay: "routes",
      showMainRoutes: false,
      statusDialog: false,
      actionDialog: false,
      dateRange: {
        startDate: '',
        endDate: ''
      },
    };
  },
  methods: {
    ...mapActions(["fetchDocumentTypes","fetchRouteStatuses", "fetchRoutes", "fetchAssignedSubRoutesList", "fetchPendingInitiateDocuments", "fetchActions",]),
    onSelectDates(value){
      this.dateRange = value
    },
    openDialog(val){
      this.actionDialog = val
    },
    closeDialog(val){
      this.statusDialog = val
      this.actionDialog = val
    },
    checker() {
      if(this.allActions.length == 0)
        this.isFetchingAction = true
      if(this.allRoutes.length == 0)
        this.isFetchingRoute = true
      if(this.getAssignedSubRoutes.length == 0)
        this.isFetchingAssignedRoute = true
      if(this.allRoutePendingDocuments.length == 0)
        this.isFetchingPendingDocuments = true
      if(this.allRouteStatuses.length == 0)
        this.isFetchingRouteStatus = true
    },
    scrollView(){
      if(window.location.hash) {
          this.tableDisplay = 'initiate_documents'
      }
    }
  },
  created() {
    this.checker()
    this.scrollView()
    if(this.loggedInPosition === 'Regional Director' || this.loggedInPosition === 'Records Officer' || this.loggedInPosition === 'Admin') {
      this.showMainRoutes = true;
      this.fetchRoutes({ itemsPerPage: 0 }).then(() => {
        this.isFetchingRoute = false
      });
    } else this.tableDisplay = "routes_assigned"
      this.fetchDocumentTypes()
      this.fetchRouteStatuses().then(() => {
        this.isFetchingRouteStatus = false
      });
      this.fetchAssignedSubRoutesList().then(() => {
        this.isFetchingAssignedRoute = false
      });
      this.fetchPendingInitiateDocuments().then(() => {
        this.isFetchingPendingDocuments = false
      });
      this.fetchActions({ bypass: false, itemsPerPage: 0 }).then(() => {
        this.isFetchingAction = false
      });
    },
    computed: mapGetters(["allRouteStatuses","allRoutePendingDocuments","loggedInPosition", "allActions", "loggedInPosition", "allRoutes", "getAssignedSubRoutes"]),
  };
</script>

<style>
  .goto {
    text-decoration: none;
  }
</style>
